export var SET_POST_VIEW_TYPE = "SET_POST_VIEW_TYPE";
export function setPostViewType(type) {
    return function (dispatch) {
        dispatch({
            type: SET_POST_VIEW_TYPE,
            payload: type,
        });
    };
}
//# sourceMappingURL=setPostViewType.js.mapexport var SET_POST_VIEW_TYPE = "SET_POST_VIEW_TYPE";
export function setPostViewType(type) {
    return function (dispatch) {
        dispatch({
            type: SET_POST_VIEW_TYPE,
            payload: type,
        });
    };
}
//# sourceMappingURL=setPostViewType.js.map